import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from "@angular/router";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {CustomsValidationDirective} from "../../_directives/customs-validation.directive";
import {UserService} from "../../_services/user.service";

declare let window: any;

@Component({
    selector: 'app-forgot',
    templateUrl: './forgot.component.html',
    styleUrls: ['../register/register.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ForgotComponent implements OnInit {

    public isSendEmail: any = false;
    public isClickSendEmail: any = false;
    public loading: any = false;
    public forgotForm: FormGroup;
    public msgErrEmail: any = null;

    constructor(private userService: UserService, private router: Router, f: FormBuilder,) {
        this.forgotForm = f.group({
            email: new FormControl('', [Validators.required, Validators.email]),
        });
    }

    ngOnInit() {
    }

    onKey() {
        this.msgErrEmail = null;
    }

    onSendEmail() {
        let self = this;
        if (this.forgotForm.valid) {
            self.loading = true;
            self.isClickSendEmail = true;
            let originFull = (window.location.origin + window.location.pathname).toLowerCase();
            let requestData = {
                "email": self.forgotForm.get('email').value,
                "origin": originFull.substr(0, originFull.indexOf(this.router.url.toLowerCase())) + '/confirm-forgot'
            };
            self.userService.forgot(requestData)
                .subscribe(data => {
                        if (true) {
                            self.isSendEmail = true;
                        }
                        console.log(data);
                    }, error => {
                        self.loading = false;
                        try {
                            let resData = JSON.parse(error._body);
                            if (resData.hasOwnProperty('result') && resData.result == false) {
                                if (resData.hasOwnProperty('type') && resData.type === '_VALIDATE_') {
                                    self.msgErrEmail = (resData.hasOwnProperty('error') && resData.error.hasOwnProperty('email')) ? resData.error.email[0] : null;
                                } else if (resData.hasOwnProperty('type') && resData.type === '_FAIL_') {
                                    self.msgErrEmail = resData.hasOwnProperty('error') ? resData.error : null;
                                } else if (error.hasOwnProperty('statusText')) {
                                    self.msgErrEmail = error.statusText;
                                }
                            }
                        } catch (e) {
                            console.log('error', error);
                        }
                    }
                );
        } else {
            CustomsValidationDirective.validateAllFormFields(self.forgotForm);
        }
    }

    isFieldValid(field: string) {
        return !this.forgotForm.get(field).valid && this.forgotForm.get(field).touched;
    }

    displayFieldCss(field: string) {
        return {
            'has-error': this.isFieldValid(field),
            'has-feedback': this.isFieldValid(field)
        };
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/forgot/forgot.component.ts